import { IoPersonOutline } from "react-icons/io5";
import { useEffect, useState } from "react";
import { getAccountSpouseInfoAsync } from "../../../../../services/accountService";
import DescriptionList from "../../../../../components/common/DescriptionList";
import Modal from "../../../../../components/common/Modal";
import SpouseForm from "./SpouseForm";

const SpouseInformation = ({ id }) => {
  const [spouse, setSpouse] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchSpouse = async () => {
      setIsLoading(true);
      const result = await getAccountSpouseInfoAsync(id);

      if (mounted) {
        setSpouse(result);
        setIsLoading(false);
      }
    };

    fetchSpouse();

    return () => {
      mounted = false;
    };
  }, [id, refresh]);

  const name = spouse
    ? `${spouse.last_name}, ${spouse.first_name} ${spouse.middle_name}`
    : "-";

  const tin = spouse ? spouse.taxpayer_identification_number ?? "-" : "-";
  const employer_name = spouse ? spouse.employer_name ?? "-" : "-";
  const employment_status = spouse ? spouse.employment_status_type : "-";

  const handleSuccess = () => {
    setShowForm(false);
    setRefresh(!refresh);
  };

  return (
    <div className="p-5">
      <div className="mt-0">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <IoPersonOutline className="mr-3 text-3xl text-gray-300" />
            <div>
              <p className="text-gray-500">Spouse Information</p>
              <span className="text-xs text-gray-400">Spouse Details</span>
            </div>
          </div>
          <button
            className="text-blue-500 text-sm"
            onClick={() => setShowForm(true)}
          >
            Edit
          </button>
        </div>
      </div>
      <div className="px-12 py-5 space-y-7">
        <div className="grid grid-cols-2">
          <DescriptionList
            label="Name"
            className="col-span-2 sm:col-span-1"
            content={name}
            isLoading={isLoading}
          />
          <DescriptionList
            label="Taxpayer Identification No."
            className="col-span-2 sm:col-span-1"
            content={tin}
            isLoading={isLoading}
          />
        </div>
        <div className="grid grid-cols-2">
          <DescriptionList
            label="Employer Name"
            className="col-span-2 sm:col-span-1"
            content={employer_name}
            isLoading={isLoading}
          />
          <DescriptionList
            label="Employment Status"
            className="col-span-2 sm:col-span-1"
            content={employment_status}
            isLoading={isLoading}
          />
        </div>
      </div>
      <Modal
        title="Spouse Information"
        isOpen={showForm}
        isLoading={isFormLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <SpouseForm
          id={id}
          data={spouse}
          isLoading={isFormLoading}
          setLoading={setIsFormLoading}
          onSuccess={handleSuccess}
        />
      </Modal>
    </div>
  );
};

export default SpouseInformation;
